/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AccountEnabledPatchForm } from '../model/models';
import { EsercenteBackofficeListFilter } from '../model/models';
import { EsercenteCassiereStatoAccountEsitoDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelEsercenteBackofficeRowDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AnonimizzaEsercenteRequestParams {
    userId: string;
}

export interface AvviaResetPasswordEsercenteRequestParams {
    userId: string;
}

export interface ForzaStatoAccountEsercenteRequestParams {
    userId: string;
    accountEnabledPatchForm: AccountEnabledPatchForm;
}

export interface GetResetPasswordLinkEsercenteRequestParams {
    userId: string;
}

export interface ListEsercentiRequestParams {
    filter: EsercenteBackofficeListFilter;
    pageable: Pageable;
}


export interface EsercentiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Anonimizza l\&#39;account di un esercente e dei suoi cassieri (SUPERADMIN).
     * Per le richieste di cancellazione ricevute fuori dall\&#39;app (PEC, sportello): il canale ordinario resta il self-service dell\&#39;esercente. Anonimizza il titolare e, a cascata, i suoi cassieri (tranne quelli condivisi con un\&#39;altra impresa, che vengono solo scollegati); azzera PEC/IBAN del profilo e i contatti dei punti vendita, disabilita gli account in Keycloak e revoca le sessioni. Le domande presentate restano nel loro stato; la partita IVA resta sul profilo ma puo\&#39; essere registrata di nuovo. Operazione IRREVERSIBILE. L\&#39;operatore che la esegue viene tracciato. 404 privacy se il target non e\&#39; un ESERCENTE.
     * @endpoint post /api/v1/gestione/esercenti/{user_id}/anonimizza
* @param requestParameters
     */
    anonimizzaEsercente(requestParameters: AnonimizzaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Avvia il reset password per un esercente (SUPERADMIN).
     * Riusa resetUserPassword (invia l\&#39;email col doppio link). 404 privacy se target non ESERCENTE; 400 se l\&#39;esercente non ha email o e\&#39; bloccato dall\&#39;amministrazione.
     * @endpoint post /api/v1/gestione/esercenti/{user_id}/reset-password
* @param requestParameters
     */
    avviaResetPasswordEsercente(requestParameters: AvviaResetPasswordEsercenteRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Blocca/abilita l\&#39;accesso di un esercente (SUPERADMIN).
     * Scrive la sentinella di blocco amministrativo reale (non aggirabile dall\&#39;utente bloccato) + Keycloak, in una sola transazione fail-fast: se Keycloak non applica la scrittura torna 400 e nulla cambia in locale. Su blocco tenta la revoca delle sessioni attive (best-effort, esito nel campo sessioni_revocate). 404 privacy se target non ESERCENTE; 409 se anonimizzato.
     * @endpoint put /api/v1/gestione/esercenti/{user_id}/stato-account
* @param requestParameters
     */
    forzaStatoAccountEsercente(requestParameters: ForzaStatoAccountEsercenteRequestParams, extraHttpRequestParams?: any): Observable<EsercenteCassiereStatoAccountEsitoDTO>;

    /**
     * Genera il link di reset password per un esercente (SUPERADMIN).
     * Verbo POST per side-effect server-side (genera/persiste un JTI). Consentito solo per l\&#39;esercente (D6): il titolare e\&#39; l\&#39;interlocutore diretto. 404 privacy se target non ESERCENTE.
     * @endpoint post /api/v1/gestione/esercenti/{user_id}/get-reset-password-link
* @param requestParameters
     */
    getResetPasswordLinkEsercente(requestParameters: GetResetPasswordLinkEsercenteRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Lista paginata degli esercenti (SUPERADMIN).
     * Filtri opzionali: q (email/nome/cognome/ragione sociale/partita IVA), stato. Default sort: email ASC, size 20. Solo \&#39;email\&#39; e\&#39; ordinabile: ogni altro valore di sort ritorna 400. Lista globale, nessun filtro per comune (l\&#39;esercente non ha comune).
     * @endpoint get /api/v1/gestione/esercenti
* @param requestParameters
     */
    listEsercenti(requestParameters: ListEsercentiRequestParams, extraHttpRequestParams?: any): Observable<PagedModelEsercenteBackofficeRowDTO>;

}
